import React from 'react';
import { GitHubIcon, LiveIcon, VisitIcon } from '../icons/ProjectsIcons.jsx';
import { useTranslation } from 'react-i18next';

const ProjectCardContent = ({
  name,
  client,
  position,
  tags,
  image,
  source_code_link,
  live_url,
  client_url,
  isImageLogo = false,
}) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col h-full">
      <div className="relative w-full h-[200px] bg-primary flex-shrink-0 flex items-center justify-center overflow-hidden">
        <img
          src={`${import.meta.env.BASE_URL}${image}`}
          alt={t(name)}
          loading="lazy"
          decoding="async"
          className={`w-full h-full object-center rounded-t-2xl ${
            isImageLogo ? 'object-contain' : 'object-cover'
          }`}
        />
        <div className="absolute inset-0 flex justify-end items-end m-3 gap-2">
          {client_url && <VisitIcon visitUrl={client_url} />}
          {live_url && <LiveIcon liveUrl={live_url} />}
          {source_code_link && (
            <div
              onClick={(e) => {
                e.stopPropagation();
                window.open(source_code_link, '_blank');
              }}
              className="w-10 h-10 rounded-full flex justify-center items-center
                 cursor-pointer bg-gray-900 hover:bg-gray-700 transition-colors"
            >
              <div className="w-1/2 h-1/2 text-white">
                <GitHubIcon />
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="p-5 flex flex-col justify-between flex-grow">
        <div>
          <div className="flex justify-between items-start min-h-[3rem]">
            <h3 className="text-white font-bold text-[23px] w-full">
              {t(name)}
            </h3>
          </div>
          <div className="mt-2">
            <p className="text-white text-[15px] font-semibold">
              {t(position)}
            </p>
            <p className="text-secondary text-[13px]">
              {client.startsWith('projects.') ? t(client) : client}
            </p>
          </div>
        </div>

        <div className="mt-4 flex flex-wrap gap-2">
          {tags.map((tag) => {
            const translatedTag = t(tag.name, { returnObjects: true });
            const tagName =
              typeof translatedTag === 'object'
                ? translatedTag.name
                : translatedTag;

            return (
              <div
                key={tag.name}
                className={`text-[12px] font-medium px-3 py-1
                                 rounded-full bg-[rgb(1,24,37)] ${tag.color}`}
              >
                {tagName}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default ProjectCardContent;
